import Spinner from '@core/components/spinner/Spinner';
import ReviewsStats from './ReviewsStats';

import classes from './ReviewsHero.module.scss';

const ReviewsHero = ({ summary, isLoading }) => {
	const testimonial = summary?.testimonial;

	return (
		<section className={classes['hero']}>
			<div className={`container ${classes['hero-inner']}`}>
				<div className={classes['intro']}>
					<h1 className={classes['title']}>Pharmuni Reviews</h1>
					<h2 className={classes['subtitle']}>What Learners Say About Our Pharma Courses</h2>
					<p className={classes['description']}>
						Read reviews from learners who have studied with Pharmuni through online courses
						designed for the pharmaceutical and life sciences industries. This page brings together
						course-specific learner feedback, including the review date, the course reviewed, and a
						direct link to explore that course. Discover learner experiences across GMP,
						pharmacovigilance, quality assurance, regulatory affairs, validation, professional
						skills, and other pharma-focused learning topics before choosing your next course.
					</p>
				</div>

				{testimonial && (
					<div className={classes['testimonial']}>
						<p className={classes['testimonial-text']}>{testimonial.comment}</p>
						<div className={classes['testimonial-author']}>
							{testimonial.user_image && (
								<img
									className={classes['author-avatar']}
									src={testimonial.user_image}
									alt={testimonial.name}
								/>
							)}
							<div className={classes['author-meta']}>
								<span className={classes['author-name']}>{testimonial.name}</span>
								{testimonial.platform_logo && (
									<img
										className={classes['platform-logo']}
										src={testimonial.platform_logo}
										alt="platform"
									/>
								)}
							</div>
						</div>
					</div>
				)}
			</div>

			<div className={`container ${classes['hero-stats']}`}>
				{isLoading ? (
					<div className={classes['stats-loading']}>
						<Spinner />
					</div>
				) : (
					summary && <ReviewsStats summary={summary} />
				)}
			</div>
		</section>
	);
};

export default ReviewsHero;
